export * from './image-loader.component'
